export default __webpack_public_path__ + "static/media/E6D3834A-4F1D-4D28-BEB5-9AB2E3D3EFE5_1_105_c.6dc803cb.jpg";